module.exports = ({
    "CDMS400TT001": "รายการผู้เข้าร่วมวิจัย",
    "CDMS400TT002": "เลือกสถานวิจัย",
    "CDMS400BTN001": "เพิ่มผู้เข้าร่วมวิจัย",
    "CDMS400LB001": "รหัสสถานวิจัย",
    "CDMS400LB002": "ชื่อสถานวิจัย",
    "CDMS400LB003": "รหัสผู้เข้าร่วมวิจัย",
    "CDMS400LB004": "วันที่ลงทะเบียนในระบบ",
    "CDMS400LB005": "จำนวนของ Open query",
    "CDMS400LB006": "สถานะ",
    "CDMS400OPT001": "มี Open query",
    "CDMS400OPT002": "Query ได้รับตอบทั้งหมดแล้ว",
    "CDMS400OPT003": "ถูกล็อก",
    "CDMS400OPT004": "ลงนามอิเล็กทรอนิกส์แล้ว",
    "CDMS400OPT005": "ตรวจสอบแล้ว",
    "CDMS400OPT006": "ตรวจสอบ SDV แล้ว",
    "CDMS400OPT007": "Freeze ข้อมูลแล้ว",
    "CDMS400OPT008": "มีหน้าที่ยังไม่มีข้อมูล",
    "CDMS400OPT009": "บันทึกแล้ว",
    "CDMS400OPT010": "กำลังสร้างข้อมูล",

    "CDMS400MSG001": "คุณต้องการเปิดการใช้งานผู้เข้าร่วมวิจัยรายนี้หรือไม่?",
    "CDMS400MSG002": "คุณต้องการปิดการใช้งานผู้เข้าร่วมวิจัยรายนี้หรือไม่?",
    "CDMS400MSG003": "ไม่พบหน้าลงทะเบียน",
    "CDMS400MSG004": "มีการตั้งค่าหน้าลงทะเบียนหลายหน้า",
    "CDMS400MSG005": "ไม่มีการตั้งค่าหมายเลขคัดกรองในหน้าลงทะเบียน",
    "CDMS400MSG006": "คุณแน่ใจหรือไม่ว่าต้องการใช้ ECS อีกครั้ง?",
    "CDMS400MSG007": "ไม่สามารถเรียกใช้ ECS ได้เนื่องจากมีหัวข้อที่ถูกปิดใช้งาน",
    "CDMS400MSG008": "ไม่สามารถลงทะเบียนเข้าร่วมวิจัยได้ เนื่องจากเวอร์ชันของไซต์ยังไม่ได้ตั้งค่าอย่างถูกต้อง",
    "COMMSG023": "เซิร์ฟเวอร์ทำงานหนักเกินไป กรุณารอสักครู่แล้วลองใหม่อีกครั้ง"
});